import { AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PaginationPageEvent } from '@snapon/design-system-angular';
import { MatSort, Sort } from '@angular/material/sort';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ConfidenceToClose, ConfidenceToCloseNames } from 'src/app/modules/shared/entities/confidence-to-close.enum';
import { AppInfoService } from 'core/app-info/app-info.service';
import { LoadingState } from 'core/common-entities/loading-state.enum';
import { ActiveTab } from 'src/app/modules/shared/entities/active-tab.enum';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { ImportItemsQuoteService } from 'src/app/modules/shared/import-quotes-and-orders/import-items-quote.service';
import { StorageValues } from '../../../shared/entities/storage-values.enum';
import { AdvancedSearchService } from '../../services/advanced-search.service';
import { QuoteListService } from '../services/quote-list.service';

@Component({
  selector: 'app-quote-list',
  templateUrl: './quote-list.component.html',
  styleUrls: ['./quote-list.component.scss'],
  standalone: false
})
export class QuoteListComponent implements OnInit, OnDestroy, AfterViewChecked {
  private subscription = new Subscription();
  appStrings: AppLocalization = this.appInfoService.appStrings;
  dateFormat = this.appInfoService.dateFormat;
  templateValues = {};
  dataLoaded = {
    templateValues: false,
    quotes: false,
    transactions: false
  };
  confidenceToClose = ConfidenceToClose;
  confidenceToCloseNames = ConfidenceToCloseNames;

  now = new Date().toISOString();
  activeTab = ActiveTab;
  currentPage = 0;
  pageSize = 15;
  pageOffset = 0;
  quoteList;
  getListMethod;
  totalRecords;
  totalPages;
  displayedColumns: string[] = [
    'accountManager',
    'name',
    'bpNumber',
    'quoteName',
    'quoteNumber',
    'quoteDate',
    'quoteType',
    'quoteStatus',
    'total',
    'action'
  ];
  isWithRadio = false;
  isLoading = true;
  isPartialLoading = false;
  isAdmin = false;
  quoteKey = StorageValues.QuoteKey;

  @ViewChild(MatSort) tableSort: MatSort;

  constructor(
    private appInfoService: AppInfoService,
    private quoteListService: QuoteListService,
    private cdRef: ChangeDetectorRef,
    private advancedSearchService: AdvancedSearchService,
    private deviceService: DeviceDetectorService,
    private router: Router,
    private importItemsQuoteService: ImportItemsQuoteService
  ) { }

  ngOnInit() {
    this.isAdmin = this.appInfoService.isAdminTypeUser();
    this.getListMethod = this.quoteListService.getQuotesList.bind(this.quoteListService);
    this.initData();
    this.subscription.add(this.quoteListService.isProcessing$.subscribe(isLoading => {
      this.isLoading = isLoading === LoadingState.loading;
      this.isPartialLoading = isLoading === LoadingState.partiallyLoaded;
    }));
    this.subscription.add(this.quoteListService.quoteList$.subscribe(value => this.quoteList = value));
    this.subscription.add(this.quoteListService.totalQuotesRecords$.subscribe(value => this.totalRecords = value));
    this.subscription.add(this.quoteListService.totalQuotesRecords$.subscribe(value => this.totalPages = Math.ceil(value / this.pageSize)));
    this.subscription.add(this.quoteListService.currentPage$.subscribe(value => this.currentPage = value - 1));
    this.isWithRadio = !!this.importItemsQuoteService.getDestinationQuoteId();
  }

  ngAfterViewChecked() {
    if (this.dataLoaded.templateValues) {
      this.cdRef.detectChanges();
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    // Clear the cached filters when leaving the quotes page
    sessionStorage.removeItem(StorageValues.CachedFilters + StorageValues.QuoteKey);
  }

  private initData() {
    this.quoteListService.getTemplateValues((templateValuesObject) => {
      this.templateValues = templateValuesObject;
      this.dataLoaded.templateValues = true;
    });
  }

  loadPage(event: PaginationPageEvent) {
    this.dataLoaded.quotes = false;
    this.currentPage = event.pageNumber;
    this.quoteListService.updatePage(event.pageNumber, {});
    this.pageOffset = (event.pageNumber - 1) * this.pageSize;
  }

  sortData(sort: Sort) {
    if (!sort.active) {
      // reset sorting due to new search, no action needed
      return;
    } else if (!sort.direction) {
      // reset sorting due to clicking the sort arrow icon, reload default list
      sort = null;
      this.quoteListService.resetSortOnQuotes();
    }

    this.resetPage();
    this.quoteListService.getQuotesList(null, sort);
  }

  resetSortIndicator(sort?: MatSort) {
    this.advancedSearchService.resetSort(this.tableSort, sort);
  }

  resetPage() {
    this.currentPage = 0;
  }

  navigateToQuote(quoteId: string) {
    this.router.navigate(['/quotes', quoteId]);
  }

  onRadioChange(row: any) {
    this.importItemsQuoteService.setSelectedQuoteId(row.id);
  }
}
